"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var IconPath =
/*#__PURE__*/
function () {
  function IconPath() {
    (0, _classCallCheck2.default)(this, IconPath);
  }

  (0, _createClass2.default)(IconPath, null, [{
    key: "get",

    /**
     * Gets full path for SVG icon from S3 bucket hosted in https://files.connectwise.com
     * 
     * @static
     * @param {string} icon 
     * @returns {string}
     * @memberof IconPath
     */
    value: function get(icon) {
      return "https://files.connectwise.com/UI/Icons/v1.0/".concat(icon, ".svg");
    }
  }]);
  return IconPath;
}();

var _default = IconPath;
exports.default = _default;